import { render, staticRenderFns } from "./AssessmentWidget.vue?vue&type=template&id=0b934da1&scoped=true"
import script from "./AssessmentWidget.vue?vue&type=script&lang=js"
export * from "./AssessmentWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b934da1",
  null
  
)

export default component.exports